import React, {Component} from 'react';
import NameComponent from './NameComponent';
import { Col, Row } from 'reactstrap';

class QuestionLineViewComponent extends Component {
    constructor(props){
        super(props)

    }

    render(){
        return(
            <Row style = {{ flexDirection:'row',display:'flex', alignItems:'left', alignContent:'left'}}>
                <Col xs = {4}>
                    <h5 className = "text text-muted">{this.props.Name}</h5>
                </Col>
                <Col xs = {7}>
                <img 
                    src = {this.props.URL}
                    style = {{marginLeft:20, height: (this.props.height/this.props.width) * 220, width: 220}}
                />
                </Col>
               
            </Row>
        )
    }
}

export default QuestionLineViewComponent